import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Root Render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// FORCE UNREGISTER SERVICE WORKER
// This ensures old cached index.html files are deleted and the new version is fetched.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();
  }).catch(error => {
    console.error(error.message);
  });
}